var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcnPin = function SvgLightIcnPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0078FF",
    d: "M10 .292c-4.458 0-8.083 3.625-8.083 8.083 0 6.158 7.35 11.167 7.666 11.375a.76.76 0 0 0 .834 0c.316-.209 7.666-5.217 7.666-11.375 0-4.458-3.625-8.083-8.083-8.083m0 11.283a3.3 3.3 0 0 1-3.3-3.3c0-1.825 1.483-3.3 3.3-3.3s3.3 1.483 3.3 3.3-1.475 3.3-3.3 3.3"
  })));
};
export default SvgLightIcnPin;